import { Component } from '@angular/core';
import { FormBuilder, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Store } from '@ngxs/store';
import { catchError, finalize, of, tap } from 'rxjs';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

import {
    AlertService,
    ButtonColors,
    ButtonModule,
    ButtonTypes,
    TextfieldModule,
} from '@ed---interne/ng-uui-components';

import { Login } from '../../../core/states/auth.state';
import { emailValidator } from '../../../shared/validators/email.validator';
import { AuthMicrosoftService } from '../../../core/services/auth.microsoft.service';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/shared/shared.module';

@UntilDestroy()
@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        SharedModule,
        TextfieldModule,
        ButtonModule,
    ],
})
export class LoginComponent {
    public ButtonTypes = ButtonTypes;
    public ButtonColors = ButtonColors;
    public loading = false;

    constructor(
        private store: Store,
        private readonly formBuilder: FormBuilder,
        private authMicrosoft: AuthMicrosoftService,
        private alertService: AlertService,
    ) {}

    public loginFormGroup = this.formBuilder.group({
        email: ['', [emailValidator()]],
        password: [''],
    });

    public get isMicrosoftActivated(): boolean {
        return this.authMicrosoft.isActivated;
    }

    public loginWithMicrosoft() {
        this.authMicrosoft.login(); // redirige vers Microsoft, reviendra sur /azure-callback
    }

    public async login() {
        this.loading = true;

        this.store
            .dispatch(
                new Login({
                    email: this.loginFormGroup.value.email || '',
                    password: this.loginFormGroup.value.password || '',
                }),
            )
            .subscribe({
                next: () => {
                    this.loading = false;
                },
                error: (error) => {
                    console.log('Erreur lors de la connexion:', error);
                    this.alertService.error('Erreur', error?.error?.message);
                    this.loading = false;
                },
            });
    }
}
